// extracted by mini-css-extract-plugin
export default {"dialog":"style_dialog__ySc2Y","communityStatus":"style_communityStatus__6hr9A","basicsType":"style_basicsType__I5mSN","buttons":"style_buttons__sgSPm"};